<script setup lang="ts">
import { useStoreProfiles } from '../../store/useStoreProfiles'
import { computed, ref, shallowRef, watchEffect } from 'vue'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
import { StoreStates } from '../../pages/PageStoreProfile.vue'
import BulkUpdateRai from './BulkUpdateRai.vue'
import TaskAttachment from '../TaskAttachment.vue'
import FetchPdf from '../FetchPdf.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { Table } from 'app/types/components/data-rendering'

const props = defineProps<{
  storeId: string | number
  isFetching: boolean
  isNative: boolean
  storeStates: StoreStates
}>()
const emit = defineEmits<{ (e: 'update:isFetching'): void }>()
const taskDataRef = ref<typeof FilteringDataDisplay | undefined>()
const isFetching = useModelWrapper(props, emit, 'isFetching')
const setFetching = (e: any) => (isFetching.value = e)

const loading = ref(true)
const taskData = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    //tasks
    const { getTaskData } = useStoreProfiles()
    taskData.value = getTaskData(props.storeId)
    loading.value = false
  },
  { flush: 'post' }
)

const showChecks = computed(() => !!(props.storeStates.isThisTimer || props.isNative))
const { taskListDisplayOptions } = useFilteringDisplayOptions({
  isFetching: props.isFetching,
  showAllChecks: showChecks,
})
//bulk rai
const setBulkRaiFilter = () => {
  if (taskDataRef.value) {
    taskDataRef.value.addCondition({
      col: 'task_start_date',
      operation: 'onOrBefore',
      dateModifier: 'today',
      value: null,
    })
    taskDataRef.value.addCondition({
      col: 'order_type',
      operation: 'isNot',
      value: 'MERCH',
    })
  }
}
const uncheckTaskData = () => {
  if (taskDataRef.value) {
    taskDataRef.value.unCheckAll()
  }
}
</script>
<template>
  <FilteringDataDisplay
    ref="taskDataRef"
    v-if="taskData"
    :key="`${storeId}-${loading}`"
    :is-loading="loading"
    :table-data="taskData"
    :options="taskListDisplayOptions"
    :collapse="true"
  >
    <template v-if="taskDataRef" #attachment="{ rowData, filterData }">
      <TaskAttachment truncate :attachment="rowData['attachment']" :filter-data="filterData" />
    </template>
    <!-- Actions for checked data -->
    <template v-if="isNative || storeStates.isThisTimer" #actions="{ checkedData }">
      <div class="q-gutter-sm">
        <FetchPdf
          v-if="isNative"
          :data="checkedData"
          field="attachment"
          @is-fetching="setFetching"
        />

        <BulkUpdateRai
          v-if="storeStates.isThisTimer"
          :tasks="checkedData"
          @set-bulk-rai-filter="setBulkRaiFilter"
          @bulk-data-change="uncheckTaskData"
        />
      </div>
    </template>
  </FilteringDataDisplay>
</template>
